// extracted by mini-css-extract-plugin
export default {"main":"Edit_main__581wS"};